export default __webpack_public_path__ + "static/media/banner-dark.5d0d9f96.jpg";